// @ts-strict-ignore
import React from 'react';

import { TwoTilesBlockData } from 'api/cms';
import { Box } from 'components/Box';

import { TwoTilesBlockTile } from './TwoTilesBlockTile';

type Props = {
  data: TwoTilesBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function TwoTilesBlock({
  data: {
    tileOneHeadline,
    tileOneText,
    tileOneButtonText,
    tileOneButtonUrl,
    tileTwoHeadline,
    tileTwoText,
    tileTwoButtonText,
    tileTwoButtonUrl,
  },
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <Box
      display="flex"
      width="100%"
      alignItems="stretch"
      flexDirection={['column', 'column', 'row']}
      justifyContent="center"
    >
      <TwoTilesBlockTile
        dataQaPrefix="tile-one"
        headline={tileOneHeadline}
        text={tileOneText}
        buttonText={tileOneButtonText}
        buttonUrl={tileOneButtonUrl}
        blockIndex={blockIndex}
        pageUpdated={pageUpdated}
      />

      <TwoTilesBlockTile
        mt={['20px', null, 0]}
        ml={[null, null, '40px']}
        dataQaPrefix="tile-two"
        headline={tileTwoHeadline}
        text={tileTwoText}
        buttonText={tileTwoButtonText}
        buttonUrl={tileTwoButtonUrl}
        blockIndex={blockIndex}
        pageUpdated={pageUpdated}
      />
    </Box>
  );
}
